import { useAuth } from '../contexts/AuthContext';

/**
 * Người dùng có quyền quản trị tổ chức không — CHỈ để ẩn/hiện nút cho gọn. Quyền thật do SERVER kiểm (bo-gateway RequireOrgAdmin:
 * org_admin hoặc global_access); đừng dựa vào hook này để bảo vệ dữ liệu.
 */
export function useIsOrgAdmin(): boolean {
  const { user } = useAuth();
  if (!user) return false;
  if (user.user_type === 'platform_user') return true; // tài khoản nền tảng có global_access
  const roles = (user.roles || user.organization_roles || []) as string[];
  return roles.includes('org_admin');
}
